.dda-progress-bar-container {
  display: flex;
  align-items: center;
}

.dda-progress-bar {
  width: 100%;
  position: relative;
  height: 8px;
  background-color: var(--dda-neutral-variant-92);
  border-radius: 4px;
}

.dda-progress-value {
  height: 100%;
  background-color: var(--dda-color-primary-40);
  position: relative;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.light-mode .dda-progress-value{
  background-color: var(--dda-primary-40);
}
.dda-tooltip {
  height: 35px;
  background-color: var(--dda-neutral-100);
  border: solid 1px var(--dda-neutral-90);
  padding: 4px 8px;
  border-radius: 4px;
  -webkit-box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  -moz-box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.04);
  font-size: 16px;
  color: var(--dda-neutral-0);
  font-weight: var(--dda-fw-500);
  white-space: nowrap;
  display: grid;
  align-items: center;
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translateX(40%);
}

.tooltip-top {
  top: -45px;
}

.dda-tooltip::before,
.dda-tooltip::after {
  content: "";
  position: absolute;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  left: 50%;
  margin-left: -10px;
}

.dda-tooltip.tooltip-top::before {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-90);
  margin-top: 0px;
}

.dda-tooltip.tooltip-top::after {
  top: 100%;
  border-top: 8px solid var(--dda-neutral-100);
  margin-top: -2px;
  z-index: 1;
}

.tooltip-bottom {
  top: 17px;
}

.dda-tooltip.tooltip-bottom::before {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-90);
  margin-bottom: 0px;
}

.dda-tooltip.tooltip-bottom::after {
  bottom: 100%;
  border-bottom: 8px solid var(--dda-neutral-100);
  margin-bottom: -2px;
  z-index: 1;
}

.dda-percentage-text {
  margin-inline-start: 8px;
  font-size: 16px;
  color: var(--dda-neutral-0);
}